module.exports = __webpack_public_path__ + "static/media/henrik_ehrnrooth.cbfe7df0.png";